import { VanDatabaseMode } from "src/graphql/generated/globalTypes";

export const vanModeFriendlyName = (mode: VanDatabaseMode): string => {
  switch (mode) {
    case VanDatabaseMode.MY_CAMPAIGN:
      return "My Campaign / EveryAction";
    case VanDatabaseMode.MY_VOTERS:
      return "My Voters";
  }
};
